import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { v4 as uuidv4 } from "uuid";
import ChatWindow from "./components/ChatWindow";
import AdminView from "./components/AdminView";
import { createSession } from "./services/api";

function Header() {
  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        bgcolor: "background.default",
        borderBottom: 1,
        borderColor: "divider",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: 80,
          px: 3,
          gap: 1.5,
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
          <Box
            component="img"
            src="/images/serc-logo.png"
            alt="SERC"
            sx={{ width: 64, height: 64, borderRadius: "50%" }}
          />
          <Typography
            variant="h4"
            sx={{
              fontFamily: "'Marcellus', Georgia, serif",
              fontWeight: 300,
              color: "text.primary",
            }}
          >
            Ask Susie
          </Typography>
        </Link>
      </Box>
    </Box>
  );
}

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        py: 2,
        px: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.disabled" sx={{ fontSize: 14 }}>
        Southeastern Reptile Conservation &middot;{" "}
        <Box
          component="a"
          href="https://www.southeastreptile.org"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "text.secondary", textDecoration: "underline" }}
        >
          southeastreptile.org
        </Box>
        {" "}&middot;{" "}
        <Box
          component="a"
          href="https://www.stickermule.com/purringturtle/item/20216371?origin=PUBLIC_PROFILE"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "text.secondary", textDecoration: "underline" }}
        >
          Get a Susie sticker
        </Box>
      </Typography>
    </Box>
  );
}

export default function App() {
  const [userId] = useState(() => uuidv4());
  const [sessionId, setSessionId] = useState(null);
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    createSession(userId)
      .then((id) => {
        if (!cancelled) {
          setSessionId(id);
          setSessionReady(true);
        }
      })
      .catch((err) => {
        console.error("Failed to create session:", err);
        // Fall back so the UI isn't stuck loading forever
        if (!cancelled) setSessionReady(true);
      });
    return () => { cancelled = true; };
  }, [userId]);

  return (
    <BrowserRouter>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Header />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Routes>
            <Route
              path="/"
              element={
                sessionReady ? (
                  <ChatWindow userId={userId} sessionId={sessionId} />
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <Typography color="text.secondary">Loading...</Typography>
                  </Box>
                )
              }
            />
            <Route path="/admin" element={<AdminView />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </BrowserRouter>
  );
}
